import { render, staticRenderFns, recyclableRender, components } from "./course.vue?vue&type=template&id=b1db4d34&scoped=true&"
var renderjs
import script from "./course.vue?vue&type=script&lang=js&"
export * from "./course.vue?vue&type=script&lang=js&"
import style0 from "./course.vue?vue&type=style&index=0&id=b1db4d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1db4d34",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/course/course.vue"
export default component.exports